import React from "react";
import "./bottom-social-icons.styles.scss";

const BottomSocialIcons = () => {
  return (
    <div className="social-icons">
    <h1>Social Icons</h1>
    </div>
  );
};

export default BottomSocialIcons;
